// extracted by mini-css-extract-plugin
export default {"button":"LpXzaZy","disabled":"cYGqURx","active":"fyxh6xK","icon":"ARNiOkY","error":"Mu4nYyO","text":"kPRvbob"};